import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedPriceListCustomer, selectPriceListCustomerState, setAction } from "../redux/slices/priceListCustomerSlice"
import { priceListCustomersAPI } from "../apis/priceListCustomersAPI"
import { priceListCustomer } from "../types/slices/priceListCustomerType"

export const usePriceListCustomerStore = () => {

    const dispatch = useDispatch()
    const { priceListCustomer, priceListSelectedCustomer, status, action } = useSelector(selectPriceListCustomerState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getPriceListCustomers = async (data:{}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListCustomersAPI.getPriceListCustomers(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createPriceListCustomer = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListCustomersAPI.createPriceListCustomer(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            dispatch(changeStatus(ApiStatus.FETCHED))
            return false
        }
    }

    const editPriceListCustomer = async (idlist: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListCustomersAPI.editPriceListCustomer(idlist, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deletePriceListCustomer = async (idlist: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListCustomersAPI.deletePriceListCustomer(idlist)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedPriceListCustomer = (detail: priceListCustomer) => {
        try {
            dispatch(onSetSelectedPriceListCustomer(detail))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionPriceListCustomer = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        priceListCustomer,
        priceListSelectedCustomer,
        status,
        action,
        //actions
        getPriceListCustomers,
        createPriceListCustomer,
        editPriceListCustomer,
        deletePriceListCustomer,
        setSelectedPriceListCustomer,
        setActionPriceListCustomer,
    }
}